import { Subject, Subscription } from 'rxjs';
import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FaqAnswer } from 'src/app/core/model/api-response/support-responce.model';

@Component({
  selector: 'app-answer-page',
  templateUrl: './answer-page.component.html',
  styleUrls: ['./answer-page.component.scss'],
})
export class AnswerPageComponent implements OnInit, OnDestroy {
  id: string;
  answer: FaqAnswer;
  title: string;
  showEdit: boolean;
  selectedType: string;
  userReaction: 'noReaction' | 'like' | 'dislike' = 'noReaction';
  voter: Subject<boolean> = new Subject<boolean>();
  voterDeleter: Subject<any> = new Subject();

  subscriptions: Subscription[] = [];

  constructor(
    private settingService: SettingService,
    private route: ActivatedRoute,
    private supportService: SupportService,
    private bottomsheetShared: BottomsheetShared
  ) {
    this.id = this.route.snapshot.paramMap.get('answerId');
    const closeButtomSheet =
      this.bottomsheetShared.closeBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.showEdit = false;
        }
      });
    const closeAndUpdateBottomsheet =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.showEdit = false;
          }
        }
      );
    const voteFaq = this.voter.subscribe((vote) => {
      this.supportService.sendVoteFaq(this.id, vote).then((res) => {});
    });
    const deleteVoteFaq = this.voterDeleter.subscribe((vote) => {
      this.supportService.deleteVoteFaq(this.id).then((res) => {});
    });
    this.subscriptions.push(
      closeAndUpdateBottomsheet,
      closeButtomSheet,
      voteFaq,
      deleteVoteFaq
    );
  }

  ngOnInit() {
    this.supportService.getFaqAnswer(this.id).then((res) => {
      console.log(res.getData().getFaqAnswerResponce());

      this.answer = res.getData().getFaqAnswerResponce().result;
      this.supportService
        .getFaqSubCategories(this.answer.subcategory)
        .then((sub) => {
          console.log();

          this.title = sub
            .getData()
            .getFaqSubCategories().faqs[0].subcategory.name;
        });
    });
  }
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe);
  }
  openSendReport() {
    this.selectedType = 'message';
    this.showEdit = true;
  }
  back() {
    this.settingService.goBack();
  }
  vote(reaction: 'like' | 'dislike') {
    if (reaction == 'like') {
      if (this.userReaction == 'noReaction' || this.userReaction == 'dislike') {
        this.userReaction = 'like';
        this.voter.next(true);
      } else if (this.userReaction == 'like') {
        this.userReaction = 'noReaction';
        this.voterDeleter.next();
      }
    } else if (reaction == 'dislike') {
      if (this.userReaction == 'noReaction' || this.userReaction == 'like') {
        this.userReaction = 'dislike';
        this.voter.next(false);
      } else if (this.userReaction == 'dislike') {
        this.userReaction = 'noReaction';
        this.voterDeleter.next();
      }
    }
  }
}
